import apiMutations from './mutations.js';
import apiActions from './actions.js';
import apiGetters from './getters.js';

export default {
    namespaced: true,
    state() {
        return {
            cmlpartition: 'CML',
            erppartition: 'ERP',
            language: 'ENG',
            // CE APIs
            INIT : '?w=CESINIT&r=usInitializeSite&vlweb=1',
            LOGIN : '?w=CESLOGIN&r=usLogin&vlweb=1',
            MENU : '?w=CESMENU&r=USGETMENULIST&vlweb=1',
            CHANGE_PASSWORD : '?w=CESACTDET&r=usChangePassword&vlweb=1',
            FORGOT_PASSWORD : '?w=CESFPWD&r=usForgotPassword&vlweb=1',
            GET_CE_PROD_ATTRIBUTES: '?w=CESPRDT&r=usGetProductDetails&vlweb=1',
            CONTACT_US: '?w=CESCNTUS&r=usContactUs&vlweb=1',
            CONTENT_CONTACT_US: '?w=CESGETCNT&r=usGetSinglePageCont&vlweb=1',
            CL_MWARE_URI: '?w=CLMWAPI&r=SearchByMeta',
            CL_MWARE_URI_MFG: '?w=CLMWAPI&r=GetManufacturers',
            CL_MWARE_SWMETADATA: '?w=CLMWAPI&r=SearchWithMetaData',
            CAT_PRESCRIP_SETT : '?w=CESINIT&r=srvGetCatPrescript&vlweb=1',
            CAT_PROD_ATTR : '?w=CESMENU&r=usGetCatProductAttr&vlweb=1',

            TAX_RATE_URI: '?w=CESCHKOUT&r=usGetTaxRate&vlweb=1',
            SHIP_RATE_URI: '?w=CESCHKOUT&r=usGetShippingRates&vlweb=1',
            PROMO_CODE_URI: '?w=CESCHKOUT&r=usValidatePromoCode&vlweb=1',
            EMAIL_ORD_SUCC_URI: '?w=CESCHKOUT&r=usOrderSuccessEmail&vlweb=1',

            // CE CUSTOMER APIs
            CREATE_CUST: '?w=CESACTDET&r=usCreateB2CUser&vlweb=1',
            CHECK_CUST: '?w=CESCHKOUT&r=usCheckUser&vlweb=1',

            //ERP APIs
            // LOGIN : '?w=Login&r=SignIn&vlweb=1',
            MENU_CATEGORIES: "?w=category&r=categories&vlweb=1",
            ABOUT: '?w=CESGETCNT&r=usGetSinglePageCont&vlweb=1',
            MAIL_SUBS: '?w=CESGETCNT&r=usSaveEmailSubs&vlweb=1',
            ORDER_HISTORY: '?w=OrderHist&r=Orders&vlweb=1',
            OPEN_ORDERS: '?w=OrderHist&r=OpenOrders&vlweb=1',
            ORDER_DETAILS: '?w=OrderHist&r=Order&vlweb=1',
            PARTS_LIST : '?w=category&r=categoryParts&vlweb=1',
            PRODUCT_DETAILS : '?w=Part&r=Detail&&vlweb=1',
            RETURN_POLICY: '?w=CESGETCNT&r=usGetSinglePageCont&vlweb=1',
            EXPAND_SELECTION: '?w=whi&r=groups&vlweb=1',
            SHIPPED_ORDERS: '?w=OrderHist&r=ShippedOrders&vlweb=1',
            SHIPPING_POLICY: '?w=CESGETCNT&r=usGetSinglePageCont&vlweb=1',
            GET_SAVED_ORDERS: '?w=Orders&r=savedOrders&vlweb=1',
            ADD_SAVED_ORDER: '?w=Orders&r=addSavedOrder&vlweb=1',
            DELETE_SAVED_ORDER: '?w=Orders&r=deleteSavedOrder&vlweb=1',
            GET_SAVED_ORDER_PARTS: '?w=Orders&r=savedOrder&vlweb=1',
            GET_SAVED_VEHICLES: '?w=Catalogs&r=lastVehicles&vlweb=1',
            ADD_SAVED_VEHICLE: '?w=Catalogs&r=lastVehiclesAdd&vlweb=1',
            GET_CUSTOMER_INFO: '?w=customer&r=info&vlweb=1',
            GET_CUSTOMER_ENROLLED: 'D15PGMLIB/lansaweb?w=customer&r=infoEnrolled&vlweb=1',
            GET_CARRIERS: '?w=WD&r=carriers&vlweb=1',
            SEARCH_PARTS: '?w=Part&r=SearchD&vlweb=1',
            DUPLICATE_ITEMS: '?w=Part&r=duplicateItem&vlweb=1',
            PLACE_ORDER: '?w=orders&r=placeOrder&vlweb=1',
            GET_SAVED_CC: '?w=payment&r=savedCC&vlweb=1',
            REMOVE_SAVED_CC: '?w=payment&r=deleteCC&vlweb=1',
            CUST_BILLING_STATUS: '?w=customer&r=billingStatus&vlweb=1',
            VALIDATE_PARTS: '?w=Part&r=validateItems&vlweb=1',
            SUBSTITUTES_PARTS: '?w=Part&r=Substitutes&vlweb=1',
            KIT_MASTER: '?w=Kit&r=Master&vlweb=1',
            LAST_CATEGORIES: '?w=category&r=lastCategories&vlweb=1',
            CATLVL_NAMES: '?w=category&r=levelNames&vlweb=1',
            CATALOG_LISTS: '?w=Catalogs&r=list&vlweb=1',
            OPEN_INVOICES: '?w=billings&r=openInvoices&vlweb=1',
            INVOICE_DETAILS: '?w=billings&r=invoiceDetail&vlweb=1',
            PAID_INVOICES: '?w=billings&r=paidInvoices&vlweb=1',
            POPULAR_CATEGORIES: '?w=category&r=PopularCategs&vlweb=1',
            CUST_CREDIT_STATUS: '?w=customer&r=creditStatus&vlweb=1',
            CUST_SAVE_ADDR: '?w=customer&r=updateAddressB2C&vlweb=1',
            CUST_UPD_SHIPT: '?w=customer&r=updateShipTo&vlweb=1',
            
            // cc payments URI api:
            CC_NEW_ORDER: '?w=orders&r=newOrder&vlweb=1',
            // CC
            CC_INPUT: '?w=payment&r=info&vlweb=1&lang=ENG&_T=1611072351543',

            STOCK_CHECK: '?w=Part&r=stockCheck',
            PART_DETAILS: '?w=Part&r=details',
            RELATED_PARTS: '?w=Part&r=relatedParts',
            LOST_LOG_SALE: '?w=orders&r=logLostSale',
            CUSTOMER_LOCATIONS: '?w=customer&r=locations',
            WD_LOCATIONS: '?w=WD&r=locations',
            WD_MFGS: '?w=WD&r=mfgs',
            WD_CREDIT_SETTINGS: '?w=WD&r=creditSettings',

            // STORE_FRONT : whi / Partslink
            // STORE_FRONT: 'whi',
            STORE_FRONT: 'Partslink',
            SF_CATCLASS : 'Partslink',
            VEHICLE_YEARS : '?r=years&vlweb=1',
            VEHICLE_MAKES : '?r=makes&vlweb=1',
            VEHICLE_MODEL : '?r=models&vlweb=1',
            VEHICLE_ENGINE: '?r=engines&vlweb=1',
            VEHICLE_GROUP: '?r=groups&vlweb=1',
            VEHICLE_YRMODEL: '?r=modelsYear&vlweb=1',
            VEHICLE_CATEGORIES: '?r=categories&vlweb=1',
            VEHICLE_PARTS: '?r=parts&vlweb=1',
            VEHICLE_COUNTERMAN: '?r=countermanQuestions&vlweb=1',
            VEHICLE_TYPE: '?r=types&vlweb=1',
            INTERCHANGE_MANUFACTURERS: '?w=whi&r=interchangeMfgs&vlweb=1',
            INTERCHANGE_SUBSTITUTES: '?w=whi&r=interchange&vlweb=1',
            BUYERS_GUIDE: '?r=buyersGuide&vlweb=1&lang=ENG&_T=1611072351543',
            VIN: '?r=vin&vlweb=1&lang=ENG&_T=1611072351543',
            RELATED_TYPES: '?w=whi&r=relatedTypes&vlweb=1',
            RELATED_ITEMS: '?w=whi&r=relatedItems&vlweb=1',
            // PL_KEYSEARCH: '?w=Partslink&r=keywordsSearch&vlweb=1',
            PL_KEYSEARCH: '?w=Partslink&r=itemKeywordsSrc&vlweb=1',
            PL_ITEMSEARCH: '?w=Partslink&r=itemSearch&vlweb=1',
            PL_VH_KEYSRC: '?w=Partslink&r=vehicleKeywordsSrc&vlweb=1',
            PL_VH_GRPSRC: '?w=Partslink&r=vehicleGroupSrc&vlweb=1',

            // MULTIPLE
            VEHICLE_CATEGORIESM: '?r=categoriesM&vlweb=1',
            VEHICLE_PARTSM: '?r=partsM&vlweb=1',
            VEHICLE_TYPEM: '?r=typesM&vlweb=1',
            VEHICLE_COUNTERMANM: '?r=countermanQuestionsM&vlweb=1',

            // typehead
            SEARCH_TYPEAHEAD: '?w=Part&r=typeahead&vlweb=1',

            // return web services
            RETURN_REASONS: '?w=RMAreturn&r=reasons&vlweb=1',
            RETURN_VALIDATE: '?w=RMAreturn&r=validate&vlweb=1',
            RETURN_SUBMIT: '?w=RMAreturn&r=submit&vlweb=1',
            RETURN_SAVEDLIST: '?w=RMAreturn&r=savedList&vlweb=1',
            RETURN_LOAD: '?w=RMAreturn&r=load&vlweb=1',
            RETURN_SAVED: '?w=RMAreturn&r=save&vlweb=1',
            RETURN_DELETE: '?w=RMAreturn&r=delete&vlweb=1',
            RETURN_ENABLED: '?w=RMAreturn&r=enabled&vlweb=1',
            RETURN_NONRMA_REASONS: '?w=RMAreturn&r=nonRMAreasons&vlweb=1',
            RETURN_NONRMA_SUBMIT: '?w=RMAreturn&r=nonRMAsubmit&vlweb=1',

            // CML messages
            CHECKOUT_MSGS: '?w=DMSMSGS&r=usCheckoutMsgs&vlweb=1',

        }
    },
    mutations: apiMutations,
    actions: apiActions,
    getters: apiGetters
};
